import { render, staticRenderFns } from "./ITVendorInfo.vue?vue&type=template&id=f41b9e1e"
import script from "./ITVendorInfo.vue?vue&type=script&lang=js"
export * from "./ITVendorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports